module.exports = "https://cdn-shared.mathletics.com/teacher-modules/teacher-class-management/192/assets/images/1ebd2f269ba5f8bd210eb5da365a0a97.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/icons/ico_groups.svg
// module id = tpQ9
// module chunks = 1